// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"V_l5q9","h3":"_1IKdeF","flexwrapper":"_130s6K"};